import { render, staticRenderFns } from "./PeriodRegister.vue?vue&type=template&id=1af84101"
import script from "./PeriodRegister.vue?vue&type=script&lang=js"
export * from "./PeriodRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports